import { render, staticRenderFns } from "./merchant-review.vue?vue&type=template&id=30e1b426"
import script from "./merchant-review.vue?vue&type=script&lang=js"
export * from "./merchant-review.vue?vue&type=script&lang=js"
import style0 from "./merchant-review.vue?vue&type=style&index=0&id=30e1b426&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports